module.exports = __webpack_public_path__ + "static/media/kominfo - maskot-01.a323a49d.png";